import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { grid, colors, distances } from '../../../styles/constants';
import { Transaction } from '../../../types/checkout';
import Modal from '../../../components/Modal';
import { H2 } from '../../../components/Typography';
import { Button } from '../../../components/Buttons';
import { Error } from '../../../types/checkout/generated';
import { Dd, Dt, Dl } from '../../../components/DescriptionList/Horizontal';

type VoidErrorProps = {
    transaction: Transaction | undefined;
    dismissModal: () => void;
    error: Error | undefined;
}

const VoidError= ({ transaction, error, dismissModal }: VoidErrorProps) => {
    const { t } = useTranslation();
    return (
        <Modal>
            <Wrapper>
                <H2>{t('payments.voidTransaction.error.title')}</H2>
                {error && (
                    <Well>
                        <Dl>
                            <Dt doubleColumn>{t('payments.voidTransaction.error.label_transaction_id')}</Dt>
                            <Dd>{transaction && transaction.id}</Dd>
                        </Dl>
                        {error.error.code && (
                            <React.Fragment>
                                <Dl>
                                    <Dt doubleColumn>{t('payments.voidTransaction.error.label_code')}</Dt>
                                    <Dd>{error.error.code}</Dd>
                                </Dl>
                            </React.Fragment>
                        )}
                        {error.error.message && (
                            <React.Fragment>
                                <Dl>
                                    <Dt doubleColumn>{t('payments.voidTransaction.error.label_message')}</Dt>
                                    <Dd>{error.error.message}</Dd>
                                </Dl>
                            </React.Fragment>
                        )}
                        {error.error.errors && (
                            <React.Fragment>
                                <ErrorInfoTitle>{t('payments.voidTransaction.error.label_info')}</ErrorInfoTitle>
                                <pre>{JSON.stringify(error.error.errors, undefined, 4)}</pre>
                            </React.Fragment>
                        )}
                    </Well>
                )}
                <Button onClick={dismissModal}>{t('payments.voidTransaction.error.button_ok')}</Button>
            </Wrapper>
        </Modal>
    );
};

export default VoidError;

const Wrapper = styled.div`
    position: relative;
    width: ${grid.spans.span5};
`;

const Well = styled.div`
    padding: ${distances.small};
    margin: ${distances.small} 0;
    background-color: ${colors.backgroundAlt};
    border: 1px solid ${colors.borderLight};
    border-radius: 4px;
`;

const ErrorInfoTitle = styled.div`
    margin-top: ${distances.tiny};
    font-weight: 700;
`;
